<template>
  <div class="info-box">
    <div class="flex-1 gap-x-3 overflow-hidden flex flex-col">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="overflow-y-auto pr-3 border-b"
      >
        <ul class="flex items-center">
          <strong>基本信息</strong>
          <li class="ml-3 text-orange-500 text-xs">
            物料包括：会议网站、设备租赁、会议物料；其它均为费用大类，请注意选择！
          </li>
        </ul>
        <ul class="flex items-baseline gap-x-5 overflow-x-auto">
          <el-form-item
            prop="d_cost_type_pid"
            :rules="[
              { required: true, message: '请选择成本类型', trigger: 'blur' },
            ]"
            class="c-el-form-item-label flex-shrink-0"
            style="width: 200px"
            :clearable="false"
          >
            <template #label>
              <div
                class="flex-1 items-baseline grid"
                style="grid-template-columns: auto 1fr"
              >
                <text class="whitespace-nowrap">成本类型</text>
              </div>
            </template>
            <el-select
              v-model="state.model.d_cost_type_pid"
              class="!w-96"
              :disabled="state.list_source?.length > 0"
              :title="
                state.list_source?.length > 0
                  ? '列表中存在采购明细，禁止修改成本类型'
                  : ''
              "
            >
              <template #label="{ label, value }">
                <div class="flex gap-x-5 !w-full">
                  <text>{{ label.name }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    {{ label.description }}
                  </div>
                </div>
              </template>
              <el-option
                v-for="item in state.cblx_data"
                :key="item"
                :label="item"
                :value="item.id"
              >
                <div class="flex gap-x-5 !w-full">
                  <text>{{ item.name }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    {{ item.description }}
                  </div>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadCblx()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="采购名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入采购名称', trigger: 'blur' },
            ]"
            class="flex-shrink-0"
            style="width: 300px"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item label="供应商采购" class="flex-shrink-0">
            <el-switch
              v-model="state.model.is_supplier_purchase"
              :active-value="1"
              :inactive-value="0"
              @change="
                (value) => {
                  if (value) {
                    onLoadGys();
                  } else {
                    delete state.model.supplier_id;
                  }
                }
              "
            />
          </el-form-item>
          <el-form-item
            label="供应商"
            prop="name"
            :rules="[
              { required: true, message: '请选择供应商', trigger: 'blur' },
            ]"
            v-if="state.model.is_supplier_purchase"
            class="flex-shrink-0"
            style="width: 300px"
          >
            <el-select
              v-model="state.model.supplier_id"
              :disabled="state.supplier_id_disabled"
              :title="
                state.supplier_id_disabled
                  ? '列表中存在从供应商导入的采购明细，禁止修改供应商'
                  : ''
              "
              @change="onLoadGys"
            >
              <template #label="{ label, value }">
                <div class="flex gap-x-5 !w-full">
                  <text>{{ label.name }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    {{ label.number }}
                  </div>
                </div>
              </template>
              <el-option
                v-for="item in state.gys_data"
                :key="item"
                :label="item"
                :value="item.id"
              >
                <div class="flex gap-x-5 !w-full">
                  <text>{{ item.name }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    <text>{{ item.number }}</text>
                  </div>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadGys(true)"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="附件" claass="flex-1">
            <template #label>
              <div class="flex items-center">
                <text>附件</text>
                <el-upload
                  :show-file-list="false"
                  :auto-upload="false"
                  multiple
                  :on-change="onFileChange"
                >
                  <el-button type="primary" size="small" link icon="plus">
                    上传
                  </el-button>
                </el-upload>
              </div>
            </template>
            <div
              class="w-full flex gap-x-5 overflow-x-auto"
              v-if="state.model.files?.length > 0"
            >
              <li
                v-for="(file, index) in state.model.files"
                class="grid items-center flex-shrink-0"
                style="grid-template-columns: 1fr auto"
              >
                <text
                  class="hover:underline cursor-pointer text-green-700"
                  @click="$openFile(file.file_url)"
                >
                  {{ file.origin_filename }}
                </text>
                <el-icon
                  color="#f00"
                  @click.stop="state.model.files?.splice(index, 1)"
                  class="ml-1 hover:scale-110 text-red-400 cursor-pointer"
                >
                  <Close />
                </el-icon>
              </li>
            </div>
            <text v-else class="text-gray-400">请上传附件~</text>
          </el-form-item>

          <!-- <el-form-item label="附件" class="flex-1">
            <c_UploadFile
              :key="state.model.id"
              :value="state.model.files"
              @change="
                (data) => {
                  state.model.files = data;
                }
              "
            />
          </el-form-item> -->
        </ul>
      </el-form>
      <div class="flex flex-col overflow-hidden flex-1 mt-3">
        <ul class="flex items-center">
          <strong class="flex-1">采购明细</strong>
          <el-input
            v-model="state.params.keywords"
            placeholder="支持类型、所属分会、名称、规格、备注关键字检索"
            class="mx-3 !w-96"
            clearable
            @keyup.enter="onSearch()"
            @clear="onSearch()"
          >
            <template #suffix>
              <el-icon
                @click="onSearch()"
                color="#a2a2a2"
                title="搜索"
                class="font-bold cursor-pointer hover:opacity-60"
                ><Search
              /></el-icon>
            </template>
          </el-input>
          <li class="text-xs text-gray-400 flex items-center">
            共
            <strong class="text-blue-500">{{
              state.list_source?.length
            }}</strong>
            条采购明细，合计
            <c_money
              :key="state.total"
              :value="state.total"
              class="ml-1 mr-10"
              :prefix="false"
              suffix="元"
              bold
              :size="20"
            />
          </li>

          <el-button
            :type="state.model.d_cost_type_pid ? 'primary' : ''"
            icon="plus"
            link
            @click="onAdd"
            :disabled="!state.model.d_cost_type_pid"
            :title="state.model.d_cost_type_pid ? '' : '请先选择成本类型'"
          >
            新增
          </el-button>
          <el-button
            :type="state.model.d_cost_type_pid ? 'warning' : ''"
            icon="plus"
            link
            @click="state.showGysk = true"
            v-if="state.model?.supplier_id"
            :disabled="!state.model.d_cost_type_pid"
            :title="state.model.d_cost_type_pid ? '' : '请先选择成本类型'"
          >
            选择常用项
          </el-button>
          <el-button
            :type="state.model.d_cost_type_pid ? 'success' : ''"
            icon="plus"
            link
            @click="state.showCbk = true"
            :disabled="!state.model.d_cost_type_pid"
            :title="state.model.d_cost_type_pid ? '' : '请先选择成本类型'"
          >
            成本库选择
          </el-button>
          <el-tooltip
            effect="dark"
            content="列表中“类型、所属分会、名称、单位、采购单价及采购数量”属性，有一项为空则认定为无效行！"
          >
            <el-button
              :type="state.list_data?.length > 0 ? 'danger' : ''"
              icon="Delete"
              link
              @click="onDeleteInvalid"
              :disabled="!state.list_data?.length > 0"
            >
              清空无效行
            </el-button>
          </el-tooltip>
          <el-tooltip effect="dark" content="清空列表中所有采购明细项">
            <el-button
              :type="state.list_data?.length > 0 ? 'danger' : ''"
              icon="delete"
              link
              :disabled="!state.list_data?.length > 0"
              @click="onClear()"
            >
              清空采购明细
            </el-button>
          </el-tooltip>
        </ul>
        <el-table
          ref="tabDom"
          :data="state.list_data"
          v-loading="!Array.isArray(state.list_data)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          class="flex-1 mt-1"
          :show-overflow-tooltip="false"
        >
          <el-table-column label="#" :width="50" type="index" />
          <el-table-column label="类型" :width="140">
            <template #default="{ row }">
              <el-select
                v-model="row.d_cost_type"
                placeholder=""
                value-key="id"
                :title="row.d_cost_type_name"
                @change="
                  (item) => {
                    row.d_cost_type_id = item.id;
                    row.d_cost_type_name = item.name;
                  }
                "
              >
                <el-option
                  v-for="item in state.lx_data"
                  :key="item"
                  :label="item.name"
                  :value="item"
                />
                <template #footer>
                  <el-button
                    plain
                    class="float-right mb-3"
                    size="small"
                    @click="onLoadLx(true)"
                  >
                    刷新
                  </el-button>
                </template>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="所属分会">
            <template #default="{ row }">
              <el-select
                v-model="row.meeting_place"
                placeholder=""
                value-key="id"
                :title="row.meeting_place_name"
                @change="
                  (item) => {
                    row.meeting_place_id = item.id;
                    row.meeting_place_name = item.name;
                  }
                "
              >
                <el-option
                  v-for="item in state.fh_data"
                  :key="item"
                  :label="item.name"
                  :value="item"
                />
                <template #footer>
                  <el-button
                    plain
                    class="float-right mb-3"
                    size="small"
                    @click="onLoadFh(true)"
                  >
                    刷新
                  </el-button>
                </template>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="名称">
            <template #default="{ row }">
              <el-input v-model="row.name" :title="row.name"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="规格" :width="140">
            <template #default="{ row }">
              <el-input
                v-model="row.specification"
                :title="row.specification"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单位" :width="90">
            <template #default="{ row }">
              <el-select
                v-model="row.d_measure_unit"
                placeholder=""
                value-key="id"
                :clearable="false"
                @change="
                  (item) => {
                    row.d_measure_unit_id = item.id;
                    row.d_measure_unit_name = item.name;
                  }
                "
              >
                <el-option
                  v-for="item in state.dw_data"
                  :key="item"
                  :label="item.name"
                  :value="item"
                />
                <template #footer>
                  <el-button
                    plain
                    class="float-right mb-3"
                    size="small"
                    @click="onLoadDw(true)"
                  >
                    刷新
                  </el-button>
                </template>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="采购单价" :width="120" align="center">
            <template #default="{ row }">
              <el-input-number
                v-model="row.price"
                :min="0"
                precision="2"
                suffix="元"
                class="!w-full"
                @focus="$onFocus"
                @change="onBuildRowTotal(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="采购数量" :width="100" align="center">
            <template #default="{ row }">
              <el-input-number
                v-model="row.count"
                :min="0"
                class="!w-full"
                @focus="$onFocus"
                @change="onBuildRowTotal(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="天数" :width="100" align="center">
            <template #default="{ row }">
              <el-input-number
                v-model="row.day_count"
                :min="0"
                class="!w-full"
                @focus="$onFocus"
                @change="onBuildRowTotal(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="备注" :width="300">
            <template #default="{ row }">
              <el-input v-model="row.remark" :title="row.remark"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="合计"
            prop="total"
            :formatter="$tab_PriceFormat"
            :width="120"
          />
          <el-table-column label="操作" :width="80" align="center">
            <template #default="{ row, column, $index }">
              <el-tooltip effect="dark" content="复制一行">
                <el-button
                  type="success"
                  link
                  size="large"
                  @click="onCopy(row, $index)"
                >
                  <template #icon>
                    <el-icon :size="16"><DocumentCopy /></el-icon>
                  </template>
                </el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除此行">
                <el-button
                  type="danger"
                  link
                  size="large"
                  @click="onDelete(row, $index)"
                >
                  <template #icon>
                    <el-icon :size="16"><Delete /></el-icon>
                  </template>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="submit-box px-2.5 !justify-end flex">
      <li class="text-xs text-gray-400 flex items-center">
        共
        <strong class="text-blue-500">{{ state.list_source?.length }}</strong>
        条采购明细，合计
        <c_money
          :key="state.total"
          :value="state.total"
          class="ml-1 mr-4"
          :prefix="false"
          suffix="元"
          bold
          :size="20"
        />
      </li>
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
    <el-dialog
      v-model="state.showGysk"
      title="选择常用项"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showGysk = false;
        }
      "
      width="95%"
      style="height: 95%"
      :modal="true"
    >
      <c_gysk
        :meeting_id="props.meeting_id"
        :d_cost_type_pid="state.model?.d_cost_type_pid"
        :supplier_id="state.model?.supplier_id"
        @confirm="onGyskConfirm"
      />
    </el-dialog>
    <el-dialog
      v-model="state.showCbk"
      title="成本库选择"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showCbk = false;
        }
      "
      width="95%"
      style="height: 95%"
      :modal="true"
    >
      <c_cbk
        :meeting_id="props.meeting_id"
        :d_cost_type_pid="state.model?.d_cost_type_pid"
        @confirm="onCbkConfirm"
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";

import {
  meeting_purchase_detail,
  meeting_purchase_add,
  meeting_purchase_edit,
} from "@/http/meeting";
import {
  dic_getCostType,
  data_getSupplier,
  data_getMeetingPlace,
  dic_getMeasureUnit,
} from "@/http/data";
import { toDecimal, post_response } from "@/utils/funcs";
import { attachment_upload } from "@/http/attachment";
import { ElMessage } from "element-plus";

import c_gysk from "./GongYingShangKu.vue";
import c_cbk from "./ChengBenKu.vue";

export default {
  components: {
    c_gysk,
    c_cbk,
  },
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    let del_item_ids = []; //删除的明细项id集合，主要用于编辑提交时
    const tabDom = ref(null);
    const formDom = ref(null);
    const state = reactive({
      list_source: [], //明细项数据源
      params: {},
      model: {
        meeting_id: props.meeting_id,
        is_supplier_purchase: 0,
        files: [],
      },
      list_data: [],
    });
    onMounted(() => {
      onLoadCblx();
      if (props.id) {
        meeting_purchase_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.total = data.amount;
            state.model.files = data.attachment || [];

            state.list_source = data.meetingPurchaseItemData?.list?.map((m) => {
              return {
                id: m.id,
                handle: "edit", //handle: "add"表示新增，"edit"表示编辑
                type: m.type, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
                meeting_place: { id: m.meeting_place_id },
                meeting_place_id: m.meeting_place_id,
                meeting_place_name: m.meetingPlace?.name,
                supplier_cost_item_id: m.supplier_cost_item_id,
                cost_item_id: m.cost_item_id,
                d_cost_type_pid: m.d_cost_type_pid,
                d_cost_type: { id: m.d_cost_type_id },
                d_cost_type_id: m.d_cost_type_id,
                d_cost_type_name: m.d_cost_type_name,
                name: m.name,
                d_measure_unit: { id: m.d_measure_unit_id },
                d_measure_unit_id: m.d_measure_unit_id,
                d_measure_unit_name: m.d_measure_unit_name,
                specification: m.specification,
                price: m.price,
                count: m.count,
                day_count: m.day_count,
                remark: m.remark,
                total: toDecimal(m.amount?.toString() || "0"),
              };
            });

            state.list_data = state.list_source;
            state.supplier_id_disabled = state.list_source.some(
              (w) => w.type == 2,
            );

            if (data.is_supplier_purchase) {
              onLoadGys();
              state.supplier_id_disabled = true;
            }

            onLoadFh();
            onLoadLx();
            onLoadDw();
          }
        });
      }
    });

    //获取成本类型
    const onLoadCblx = () => {
      dic_getCostType({ pid: 0 }).then((res) => {
        if (res.status == 200) state.cblx_data = res.data?.data || [];
      });
    };

    //获取供应商     选择供应商采购时才执行
    const onLoadGys = (refresh) => {
      if (!state.gys_data && (state.model?.is_supplier_purchase || refresh)) {
        data_getSupplier().then((res) => {
          if (res.status == 200) state.gys_data = res.data?.data?.list || [];
        });
      }
    };

    //获取分会  添加采购项时获取
    const onLoadFh = (refresh) => {
      if (!state.fh_data || refresh) {
        data_getMeetingPlace(props.meeting_id).then((res) => {
          if (res.status == 200) state.fh_data = res.data?.data?.list || [];
        });
      }
    };

    //获取采购项类型 添加采购项时获取
    const onLoadLx = (refresh) => {
      if (state.model.d_cost_type_pid && (!state.lx_data || refresh)) {
        dic_getCostType({ pid: state.model.d_cost_type_pid }).then((res) => {
          if (res.status == 200) state.lx_data = res.data?.data || [];
        });
      }
    };

    //获取采购项单位 添加采购项时获取
    const onLoadDw = (refresh) => {
      if (!state.dw_data || refresh) {
        dic_getMeasureUnit().then((res) => {
          if (res.status == 200) state.dw_data = res.data?.data || [];
        });
      }
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.model.files = [...state.model.files, ...res.data.data];
        }
      });
    };

    const onSearch = () => {
      if (state.params.keywords) {
        state.list_data = state.list_source.filter(
          (w) =>
            w.d_cost_type_name?.includes(state.params.keywords) ||
            w.meeting_place_name?.includes(state.params.keywords) ||
            w.name?.includes(state.params.keywords) ||
            w.specification?.includes(state.params.keywords) ||
            w.remark?.includes(state.params.keywords),
        );
      } else {
        state.list_data = state.list_source;
      }
    };

    //新增一行
    const onAdd = () => {
      state.params = {};
      state.list_source.push({
        sort: state.list_source.length,
        handle: "add",
        d_cost_type_pid: state.model.d_cost_type_pid,
        type: 0, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
      });
      state.list_data = state.list_source;
      onLoadFh();
      onLoadLx();
      onLoadDw();

      setTimeout(() => {
        tabDom.value.setScrollTop(1000000);
      }, 200);
    };

    //复制一行
    const onCopy = (row) => {
      let data = JSON.parse(JSON.stringify(row));
      data.handle = "add";
      delete data.id;
      const index = state.list_source.findIndex(
        (e) => JSON.stringify(e) == JSON.stringify(row),
      );
      if (index > -1) {
        state.list_source.splice(index + 1, 0, data);
        console.log(state.list_source);
        onSearch();
        onBuildTotal();
      }
    };

    //采购单价、数量、天数改变时，计算行内合计，合计=采购单价*数量*天数
    const onBuildRowTotal = (row) => {
      if (typeof row.price == "number" && typeof row.count == "number") {
        row.total = toDecimal(row.price.toString() || "")
          .times(toDecimal(row.count.toString() || ""))
          .times(toDecimal((row.day_count || "1").toString()));

        onBuildTotal();
      }
    };

    //计算总合计
    const onBuildTotal = () => {
      const total = state.list_source.reduce((pre, cur) => {
        return pre.plus(toDecimal(cur.total?.toString() || ""));
      }, toDecimal("0"));
      state.total = total;
      state.supplier_id_disabled = state.list_source.some((w) => w.type == 2);
    };

    //成本库选择完成事件
    const onCbkConfirm = (data) => {
      if (data.meeting_places?.length > 0) {
        data.meeting_places.forEach((place) => {
          data.rows?.forEach((e) => {
            state.list_source.push({
              handle: "add",
              type: 1, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
              meeting_place: { id: place.id },
              meeting_place_id: place.id,
              meeting_place_name: place.name,
              cost_item_id: e.id,
              d_cost_type_pid: state.model.d_cost_type_pid,
              d_cost_type: { id: e.d_cost_type_id },
              d_cost_type_id: e.d_cost_type_id,
              d_cost_type_name: e.d_cost_type_name,
              name: e.name,
              d_measure_unit: { id: e.d_measure_unit_id },
              d_measure_unit_id: e.d_measure_unit_id,
              d_measure_unit_name: e.d_measure_unit_name,
              specification: e.specification,
              price: e.price,
            });
          });
        });
      } else {
        data.rows?.forEach((e) => {
          state.list_source.push({
            handle: "add",
            type: 1, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
            cost_item_id: e.id,
            d_cost_type_pid: state.model.d_cost_type_pid,
            d_cost_type: { id: e.d_cost_type_id },
            d_cost_type_id: e.d_cost_type_id,
            d_cost_type_name: e.d_cost_type_name,
            name: e.name,
            d_measure_unit: { id: e.d_measure_unit_id },
            d_measure_unit_id: e.d_measure_unit_id,
            d_measure_unit_name: e.d_measure_unit_name,
            specification: e.specification,
            price: e.price,
          });
        });
      }

      onLoadFh();
      onLoadLx();
      onLoadDw();
      state.params = {};
      state.list_data = state.list_source;
      delete state.showCbk;
    };

    //供应商常用项选择完成事件
    const onGyskConfirm = (data) => {
      if (data.meeting_places?.length > 0) {
        data.meeting_places.forEach((place) => {
          data.rows?.forEach((e) => {
            state.list_source.push({
              handle: "add",
              type: 2, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
              meeting_place: { id: place.id },
              meeting_place_id: place.id,
              meeting_place_name: place.name,
              cost_item_id: e.cost_item_id,
              supplier_cost_item_id: e.id,
              d_cost_type_pid: state.model.d_cost_type_pid,
              d_cost_type: { id: e.d_cost_type_id },
              d_cost_type_id: e.d_cost_type_id,
              d_cost_type_name: e.d_cost_type_name,
              name: e.name,
              d_measure_unit: { id: e.d_measure_unit_id },
              d_measure_unit_id: e.d_measure_unit_id,
              d_measure_unit_name: e.d_measure_unit_name,
              specification: e.specification,
              price: e.price,
            });
          });
        });
      } else {
        data.rows?.forEach((e) => {
          state.list_source.push({
            handle: "add",
            type: 2, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
            cost_item_id: e.cost_item_id,
            supplier_cost_item_id: e.id,
            d_cost_type_pid: state.model.d_cost_type_pid,
            d_cost_type: { id: e.d_cost_type_id },
            d_cost_type_id: e.d_cost_type_id,
            d_cost_type_name: e.d_cost_type_name,
            name: e.name,
            d_measure_unit: { id: e.d_measure_unit_id },
            d_measure_unit_id: e.d_measure_unit_id,
            d_measure_unit_name: e.d_measure_unit_name,
            specification: e.specification,
            price: e.price,
          });
        });
      }

      onLoadFh();
      onLoadLx();
      onLoadDw();
      state.params = {};
      state.list_data = state.list_source;
      state.supplier_id_disabled = true;
      delete state.showGysk;
    };

    //清空无效行
    const onDeleteInvalid = () => {
      state.list_source = state.list_source.filter(
        (e) =>
          ((e.type === 1 && e.cost_item_id) ||
            (e.type === 2 && e.supplier_cost_item_id && e.cost_item_id) ||
            e.type === 0) &&
          e.meeting_place_id &&
          e.d_cost_type_id &&
          e.name &&
          e.d_measure_unit_id &&
          typeof e.price == "number" &&
          typeof e.count == "number",
      );
      onSearch();
    };

    //删除行
    const onDelete = (row) => {
      if (row.handle == "edit") del_item_ids.push(row.id);

      const index = state.list_source.findIndex(
        (e) => JSON.stringify(e) == JSON.stringify(row),
      );
      if (index > -1) {
        state.list_source.splice(index, 1);
        onSearch();
        onBuildTotal();
      }
    };

    //清空
    const onClear = () => {
      del_item_ids = [
        ...del_item_ids,
        ...state.list_source.filter((m) => m.handle == "edit").map((m) => m.id),
      ];
      state.list_source = [];
      state.list_data = [];
      state.total = 0;
      state.supplier_id_disabled = false;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (!state.list_source || state.list_source?.length <= 0) {
            ElMessage.error("请添加采购明细");
            return false;
          }

          if (
            state.list_source.some(
              (e) =>
                (e.type === 1 && !e.cost_item_id) ||
                (e.type === 2 &&
                  (!e.supplier_cost_item_id || !e.cost_item_id)) ||
                !e.meeting_place_id ||
                !e.d_cost_type_id ||
                !e.name ||
                !e.d_measure_unit_id ||
                typeof e.price != "number" ||
                typeof e.count != "number",
            )
          ) {
            ElMessage.error(
              "采购明细项中包含无效行，请完善或者清空无效行后再提交！",
            );
            return false;
          }

          state.model.attachment = JSON.stringify(
            state.model.files?.map((m) => m.id),
          );

          if (props.id) {
            state.model.add_item_data = state.list_source.filter(
              (m) => m.handle == "add",
            );
            state.model.edit_item_data = state.list_source.filter(
              (m) => m.handle == "edit",
            );
            state.model.del_item_id = del_item_ids;
            meeting_purchase_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            state.model.add_item_data = state.list_source;
            meeting_purchase_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      tabDom,
      onLoadCblx,
      onLoadGys,
      onLoadFh,
      onLoadLx,
      onLoadDw,
      onFileChange,
      onAdd,
      onCopy,
      onCbkConfirm,
      onGyskConfirm,
      onDeleteInvalid,
      onBuildRowTotal,
      onBuildTotal,
      onDelete,
      onClear,
      onSubmit,
      onSearch,
    };
  },
};
</script>

<style lang="less" scoped></style>
